import type { QuillFormats } from "./typesV2";

export const HORIZONTAL_PADDING_RATIO = 1 / 3;
export const BULLETED_RADIUS_RATIO = 1 / 10;
export const STRIKE_HEIGHT_RATIO = 1 / 10;
export const STRIKE_COLOR = "#2d2d2d";
export const DEFAULT_TEXT_COLOR = "#000";
export const LINK_COLOR = "#0b99ff";
export const MAX_SYMBOLS_IN_LINE = 85;
export const MIN_TEXT_WIDTH = 50;
export const TEXT_WIDTH_CACHE_LIMIT = 10000;
export const TEXT_RATIO_FOR_PLACEHOLDER = 0.0055;
export const QUILL_BLOCK_FORMATS: QuillFormats[] = ["align", "list"];
export const SAFETY_PIXELS = 2;
export const UNDERLINE_HEIGHT_RATIO = 0.06;
export const UNDERLINE_VERTICAL_ADJUSTMENT = 2;
export const LINK_ADJUSTMENT_WIDTH = 1;
export const DEFAULT_FONT_SIZE = 16;
export const QUILL_FORMATS: QuillFormats[] = [
    "bold",
    "underline",
    "strike",
    "italic",
    "link",
    "color",
    "align",
    "list",
];
